module.exports = __webpack_public_path__ + "img/bookshelf_huihua.3aee4074.png";